module.exports = __webpack_public_path__ + "static/media/snowy-3.b6eea2cf.svg";